import { render, staticRenderFns } from "./amplification.vue?vue&type=template&id=05e35b5c&scoped=true&"
import script from "./amplification.vue?vue&type=script&lang=js&"
export * from "./amplification.vue?vue&type=script&lang=js&"
import style0 from "./amplification.vue?vue&type=style&index=0&id=05e35b5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e35b5c",
  null
  
)

export default component.exports